import script from "./LettersFont.vue?vue&type=script&setup=true&lang=js"
export * from "./LettersFont.vue?vue&type=script&setup=true&lang=js"

import "./LettersFont.vue?vue&type=style&index=0&id=de924fc8&lang=scss"

const __exports__ = script;

export default __exports__